export const update = {
  form: {
    name: 'Name',
    manufacturer: 'Manufacturer',
    supplier: 'Supplier',
    price: 'Price',
    inventory: 'Inventory',
    addNew: 'Add New',
    requireName: 'Please input name',
    requireManufacture: 'Please input manufacture name',
    requireSupplier: 'Please input supplier name',
    requirePrice: 'Please input price',
    requireInventory: 'Please input inventory',
    save: 'Save',
    cancel: 'Cancel',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Edit Washing Machine Part',
    back: 'Back',
  },
}
